import React, { useMemo } from 'react';

import { Button, PlusNChipList } from '@components/index';
import { DropdownOption } from 'types/dropdown';
import { Tag } from 'types/lead-management';

import { deriveDarkColor } from '../utils/common';

interface LeadTagsProps {
  handleAddTagButtonClick?: () => void;
  className?: string;
  tags?: Tag[];
  showAddButton?: boolean;
  showAllTags?: boolean;
}

const MAX_VISIBLE = 1;

const LeadTags: React.FC<LeadTagsProps> = ({
  tags,
  handleAddTagButtonClick,
  className = '',
  showAddButton = true,
  showAllTags = false
}) => {
  const tagOptions: DropdownOption[] = useMemo(
    () =>
      tags?.map((tag) => ({
        id: tag.id,
        label: tag.name,
        value: String(tag.id),
        style: {
          background: tag.color || '#e5e7eb',
          color: deriveDarkColor(tag.color || '#e5e7eb')
        }
      })) || [],
    [tags]
  );

  const addButtonClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
    handleAddTagButtonClick?.();
    evt.stopPropagation();
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <PlusNChipList
        id={`lead-tags-${tags?.map((t) => t.id).join('-')}`}
        selectedOptions={tagOptions}
        displayChipsCount={showAllTags ? tagOptions.length : MAX_VISIBLE}
        isCloseIconRequired={false}
        plusNChipBgColor="bg-[#E8FFF4]"
        plusNChipTextColor="text-primary"
        chipClassName="!px-4 !py-1 !h-auto"
        tooltipChipClassName="!px-2 !py-1 !h-auto"
        tooltipColor="white"
        className="gap-2"
      />
      {showAddButton && (
        <Button
          label="Add Tags"
          handleClick={addButtonClick}
          variant="tertiary"
          size="small"
          className="border-cofeeGreyBlue150 !h-9 !rounded-3xl !bg-white !px-2 !py-1.5 hover:!bg-gray-50"
          labelStyle="!font-medium !text-sm !text-darkGrey"
          leftIconName="add-grey"
          leftIconStyle="!size-3"
        />
      )}
    </div>
  );
};

export default LeadTags;
